export interface PrivacyPolicySection {
  title: string;
  paragraphs?: string[];
  bullets?: string[];
}

export const PRIVACY_POLICY_TITLE = 'Политика обработки персональных данных';
export const PRIVACY_POLICY_SUBTITLE = 'Политика конфиденциальности';

export const PRIVACY_POLICY_SECTIONS: PrivacyPolicySection[] = [
  {
    title: 'Общие положения',
    paragraphs: [
      'Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» и определяет порядок обработки персональных данных и меры по обеспечению их безопасности, предпринимаемые ИП Анников Павел Андреевич.',
      'Оператор ставит своей важнейшей целью соблюдение прав и свобод человека и гражданина при обработке персональных данных, включая защиту права на неприкосновенность частной жизни, личную и семейную тайну.',
      'Политика применяется ко всей информации, которую Оператор может получить о посетителях веб-сайта https://inhound.club.',
    ],
  },
  {
    title: 'Основные понятия',
    bullets: [
      'Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств вычислительной техники.',
      'Обработка персональных данных — любое действие или совокупность действий с персональными данными, включая сбор, запись, хранение, использование, передачу, обезличивание, блокирование, удаление и уничтожение.',
      'Оператор — лицо, самостоятельно организующее и осуществляющее обработку персональных данных, а также определяющее цели и состав такой обработки.',
      'Пользователь — любой посетитель веб-сайта https://inhound.club.',
      'Персональные данные — любая информация, относящаяся прямо или косвенно к определённому или определяемому пользователю сайта.',
    ],
  },
  {
    title: 'Права и обязанности оператора',
    bullets: [
      'Оператор вправе получать от субъекта персональных данных достоверную информацию и документы, содержащие персональные данные.',
      'Оператор вправе продолжить обработку персональных данных без согласия субъекта при наличии оснований, предусмотренных Законом о персональных данных.',
      'Оператор обязан предоставлять субъекту персональных данных информацию, касающуюся обработки его персональных данных.',
      'Оператор обязан организовывать обработку персональных данных в порядке, установленном законодательством Российской Федерации.',
      'Оператор обязан публиковать настоящую Политику и принимать правовые, организационные и технические меры для защиты персональных данных.',
    ],
  },
  {
    title: 'Права и обязанности субъектов персональных данных',
    bullets: [
      'Субъект персональных данных вправе получать сведения об обработке его персональных данных и требовать их уточнения, блокирования или уничтожения, если данные неполные, устаревшие, неточные, незаконно полученные или не требуются для заявленной цели обработки.',
      'Субъект персональных данных вправе отозвать согласие на обработку и направить требование о прекращении обработки персональных данных.',
      'Субъект персональных данных вправе обжаловать неправомерные действия или бездействие оператора в уполномоченный орган или в суд.',
      'Субъект персональных данных обязан предоставлять оператору достоверные данные и сообщать об их обновлении или изменении.',
    ],
  },
  {
    title: 'Принципы обработки персональных данных',
    bullets: [
      'Обработка персональных данных осуществляется на законной и справедливой основе.',
      'Обработка ограничивается достижением конкретных, заранее определённых и законных целей.',
      'Обрабатываются только персональные данные, соответствующие целям их обработки.',
      'Хранение персональных данных осуществляется не дольше, чем этого требуют цели обработки, если иной срок не установлен законом или договором.',
      'По достижении целей обработки персональные данные подлежат уничтожению либо обезличиванию, если иное не предусмотрено федеральным законом.',
    ],
  },
  {
    title: 'Цели обработки персональных данных',
    bullets: [
      'Предоставление пользователю доступа к сервисам, информации и материалам, содержащимся на веб-сайте.',
      'Обрабатываемые данные: фамилия, имя, отчество, электронный адрес, номера телефонов.',
      'Правовое основание: договоры, заключаемые между оператором и субъектом персональных данных.',
      'Виды обработки: сбор, запись, систематизация, накопление, хранение, уничтожение и обезличивание персональных данных, а также отправка информационных писем на адрес электронной почты.',
    ],
  },
  {
    title: 'Условия обработки персональных данных',
    bullets: [
      'Обработка осуществляется с согласия субъекта персональных данных, если иное не предусмотрено законодательством Российской Федерации.',
      'Обработка допускается в случаях, когда она необходима для исполнения договора, стороной которого является субъект персональных данных, либо для осуществления прав и законных интересов оператора или третьих лиц при условии соблюдения прав субъекта.',
      'Обрабатываются общедоступные данные и данные, подлежащие обязательному раскрытию, в случаях, предусмотренных федеральным законом.',
    ],
  },
  {
    title: 'Порядок сбора, хранения и передачи данных',
    bullets: [
      'Безопасность персональных данных обеспечивается правовыми, организационными и техническими мерами, необходимыми для выполнения требований законодательства.',
      'Персональные данные пользователя не передаются третьим лицам, за исключением случаев, предусмотренных законодательством или отдельным согласием пользователя.',
      'Для актуализации персональных данных пользователь может направить уведомление на адрес pavelannikov@inhound.club с пометкой «Актуализация персональных данных».',
      'Пользователь может отозвать согласие на обработку персональных данных, направив уведомление на адрес pavelannikov@inhound.club с пометкой «Отзыв согласия на обработку персональных данных».',
      'Сторонние сервисы, включая платежные системы и средства связи, хранят и обрабатывают данные в соответствии со своими собственными документами; оператор не несёт ответственности за действия таких третьих лиц.',
    ],
  },
  {
    title: 'Действия с персональными данными',
    bullets: [
      'Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление и уничтожение персональных данных.',
      'Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей информации по информационно-телекоммуникационным сетям или без таковой.',
    ],
  },
  {
    title: 'Трансграничная передача персональных данных',
    paragraphs: [
      'До начала трансграничной передачи персональных данных оператор обязан уведомить уполномоченный орган по защите прав субъектов персональных данных о своём намерении осуществлять такую передачу и получить предусмотренные законодательством сведения от иностранных получателей персональных данных.',
    ],
  },
  {
    title: 'Конфиденциальность персональных данных',
    paragraphs: [
      'Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать и не распространять персональные данные без согласия субъекта, если иное не предусмотрено федеральным законом.',
    ],
  },
  {
    title: 'Заключительные положения',
    bullets: [
      'Пользователь может получить разъяснения по вопросам обработки персональных данных, обратившись по электронной почте pavelannikov@inhound.club.',
      'В документе отражаются любые изменения политики обработки персональных данных; политика действует бессрочно до замены новой версией.',
      'Актуальная версия политики размещена по адресу https://inhound.club/politics-conf.',
    ],
  },
];
